<app-base-modal [disableClose]="true" [title]="data.title" bodyClass="none">
    <app-circle-warn header></app-circle-warn>
    <app-plain-text-content
        content
        [text]="data.description"
    ></app-plain-text-content>
    <!--  -->

    <ng-container *ngIf="data.withRefresh; else onlyConfirm" actions>
        <div class="d-flex flex-column text-center" style="width: 60%">
            <button
                class="btn btn-primary btn-action"
                (click)="confirm()"
                translate
            >
                system-warnings-modal.buttons.refresh
            </button>
            <a class="btn" translate class="mt-2" (click)="close()">
                system-warnings-modal.buttons.postpone
            </a>
        </div>
    </ng-container>
    <ng-template #onlyConfirm>
        <app-action-confirm
            type="done"
            doneBtnTitle="system.confirm"
            (doneClick)="confirm()"
        >
        </app-action-confirm>
    </ng-template>
</app-base-modal>
